export default {
  mutationTypes: {
    shippingInfoWasLoaded: 'SHIPPING_INFO_WAS_LOADED',
  },
  actionTypes: {
    loadShippingInfo: 'LOAD_SHIPPING_INFO',
    printLabel: 'PRINT_LABEL',
    printLabelMixed: 'PRINT_LABEL_MIXED',
  },
  getterTypes: {
    shippingInfo: 'GET_SHIPPING_INFO',
  },
};
